import { getHoursPerDay } from './common'

export const calculateCarPrice = (car: any, userSearch: any, kmDistance: number = 0) => {
  if (!car || !userSearch) return { price: 0, dailyrate: 0, isCalculating: false }

  let price = 0
  let dailyrate = 0
  let isCalculating = false

  if (userSearch.type === 'hourly' && car.chaufferLocation) {
    const loc = car.chaufferLocation
    const perHour = parseFloat(loc.rate_per_hour || '0')
    const baseFare = parseFloat(loc.base_fare || '0')
    
    const locHours = parseFloat(loc.hours_per_day || '0')
    const supplierHours = parseFloat(car.supplier?.hours || '0')
    const finalHours = locHours > 0 ? locHours : (supplierHours > 0 ? supplierHours : 10)

    const h = Number(userSearch.hours ?? 0)
    const hoursPerDay = getHoursPerDay()
    const days = h > 0 ? h / (hoursPerDay || 10) : 0

    if (baseFare > 0) {
      price = baseFare * days
      dailyrate = baseFare
    } else if (perHour > 0) {
      price = perHour * (days * finalHours)
      dailyrate = perHour * finalHours
    }
  } else if (userSearch.type === 'distance' && car.transferLocation) {
    const loc = car.transferLocation
    const distance = kmDistance || 0
    
    if (loc.base_fare != null && loc.cost_per_km != null) {
      const baseFare = parseFloat(loc.base_fare || '0')
      const costPerKm = parseFloat(loc.cost_per_km || '0')
      const minKm = parseFloat(loc.min_km || '0')
      
      if (distance === 0) {
        isCalculating = true
        price = 0
        dailyrate = 0
      } else {
        let calculatedPrice = baseFare
        if (distance > minKm) {
          calculatedPrice += (distance - minKm) * costPerKm
        }
        price = calculatedPrice
        dailyrate = 0
      }
    } else {
      price = parseFloat(loc.rate || '0')
    }
  }

  // add commission
  if (price > 0 && car.priceFactor > 0) {
    const factor = (100 - car.priceFactor) / 100
    price = price / factor
    if (dailyrate > 0) {
      dailyrate = dailyrate / factor
    }
  }

  return { price, dailyrate, isCalculating }
}
